export default __webpack_public_path__ + "static/media/cow-six.dc63010b.jpeg";